export default __webpack_public_path__ + "static/media/Asus Nexus 7 (2013).8399f169.png";